import { getApiAuthState, getGetApiAdminUserManagerGetUserQueryKey, usePatchApiAdminUserManagerChangeUserDisplayName, usePutApiUserChangeDisplayName } from "@/API";
import { useAuthStore } from "@/Stores/AuthStore";
import { Group, Button, Modal, TextInput } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { notifications } from "@mantine/notifications";
import { useQueryClient } from "@tanstack/react-query";
import { PropsWithChildren, useEffect, useState } from "react";
import { stringToPath } from "remeda";

export function ChangeUserDisplayNameButton(props: { userId: string, initialValue: string } & PropsWithChildren) {
    const queryClient = useQueryClient()
    const [opened, { open, close }] = useDisclosure(false);
    const [name, setName] = useState(props.initialValue)
    const changeUserDisplayName_Mutation = usePatchApiAdminUserManagerChangeUserDisplayName()
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        if (opened) setName(props.initialValue)
    }, [opened])
    return <>
        <div onClick={open}>
            {props.children}
        </div>
        <Modal opened={opened} onClose={close} title="更改顯示名稱">
            <TextInput
                value={name!}
                onChange={(event) => setName(event.target.value)}
            />
            <Group justify="flex-end" mt="md">
                <Button loading={loading} onClick={async () => {
                    setLoading(true)
                    try {
                        await changeUserDisplayName_Mutation.mutateAsync({
                            params: {
                                userId: props.userId,
                                newDisplayName: name
                            }
                        })
                        queryClient.invalidateQueries({
                            queryKey: getGetApiAdminUserManagerGetUserQueryKey({
                                userId: props.userId
                            })
                        })
                        notifications.show({ message: "更改成功" })
                        close()
                    } catch (e) {
                        notifications.show({ message: "更改失敗", color: "red" })
                    }
                    setLoading(false)
                }}>更改</Button>
            </Group>
        </Modal>
    </>
}